module.exports = __webpack_public_path__ + "img/ttlmLogo.41de1ae5.png";